const FilterValues = {
    STRING: 'STRING',
    BOOLEAN: 'BOOLEAN',
    NUMBER: 'NUMBER',
    RATING: 'RATING',
    DATE: 'DATE',
    GENDER: 'GENDER',
    NATIONALITY: 'NATIONALITY',
    COUNTRY: 'COUNTRY',
    LANGUAGE: 'LANGUAGE',
    STATUS: 'STATUS',
    TAG: 'TAG',
}

module.exports = FilterValues
